<template>
  <div class="market_index">
    <div class="banner">
      <van-image
        :src="formData.image1s && formData.image1s[0].imageUrl+'?x-oss-process=style/style_detail_banner_img'"
      >
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
    </div>
    <div class="item">
      <div class="p">商场介绍</div>
      <div class="P1" v-html="formData.info"></div>
    </div>
    <div class="item" v-if="formData.image2s && formData.image2s.length>0">
      <div class="p">商场图片</div>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in  formData.image2s" :key="index">
          <van-image
            :src="item.imageUrl && item.imageUrl+'?x-oss-process=style/style_detail_banner_img'"
          ></van-image>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="item">
      <div class="p">商场证照</div>
      <van-cell title="证照详情" value="去查看" is-link @click="setBrandInfo"></van-cell>
    </div>
    <div class="item" v-if="formData.branches && formData.branches.length>0">
      <div class="title">
        <van-divider dashed>商场上架品牌</van-divider>
      </div>
      <div class="imgs" :class="{'heigth200':arrow=='arrow-down'}">
        <div
          class="item_logo"
          v-for="(item,index) in formData.branches"
          :key="index"
          @click="checkBarnd(item.id)"
        >
          <img
            :src="item.branchIcon && item.branchIcon.imageUrl+'?x-oss-process=image/resize,w_170/format,png'"
          />
          <p class="logoname van-ellipsis">{{item.logoName}}</p>
        </div>
        <div class="up_flx" :class="{'fex':arrow=='arrow-up'}">
          <p @click="upArrow">
            {{arrow=='arrow-down'?'查看所有品牌':'收起所以品牌'}}
            <van-icon :name="arrow" />
          </p>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="yellowbg" @click="follow">{{formData.isFollow ?'已关注':'关注'}}</div>
    </div>
  </div>
</template>
<script>
import { isWeChatApplet } from "@/utils/util";
import http from "@/utils/axios";
export default {
  data() {
    return {
      arrow: "arrow-down",
      formData: {}
    };
  },
  methods: {
    getMarketIndex() {
      if (this.$route.query.id) {
        http({
          url: "shop/user/shop/" + this.$route.query.id,
          method: "get"
        }).then(rps => {
          if (rps.code == 200) {
            this.formData = rps.data;
            this.$loading.hide();
          }
        });
      }
    },
    async checkBarnd(id) {
      if (await isWeChatApplet()) {
        this.$router.push({ path: "/brandindex/", query: { id: id } });
      } else {
        wx.miniProgram.navigateTo({
          url: "/product/pages/store-detail/index?storeid=" + id
        });
      }
    },
    setBrandInfo() {
      let { extended, license } = this.formData;
      let params = {
        extended: extended,
        license: license
      };
      window.sessionStorage.setItem("extended", JSON.stringify(params));
      this.$router.push({ path: "/brandinfo" });
    },
    //关注事件
    follow() {
      if (this.formData.isFollow) {
        this.$dialog
          .confirm({
            message: "是否取消关注",
            title: "提示"
          })
          .then(rps => {
            this.setFollow(true);
          });
      } else {
        this.setFollow(false);
      }
    },
    // 是否取消关注
    setFollow(isbool) {
      http({
        url: "shop/user/shop/follow/" + this.$route.query.id,
        method: "put"
      }).then(rps => {
        if (rps.code === 200) {
          let mes = "关注成功！";
          if (isbool) {
            mes = "已取消关注";
          }
          this.$toast(mes);
          this.getMarketIndex();
        } else {
          this.$toast(rps.message);
        }
      });
    },
    upArrow() {
      this.arrow = this.arrow == "arrow-up" ? "arrow-down" : "arrow-up";
    }
  },
  created() {
    this.getMarketIndex();
  }
};
</script>
<style lang="less" scoped>
.market_index {
  padding: 20px;
  background: #fff;
  .banner {
    width: 710px;
  }
  .item {
    .up_flx {
      font-size: 28px;
      color: #ccc;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      height: 130px;
      position: absolute;
      bottom: 10px;
      right: 0;
      left: 0;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 100%
      );
    }
    .imgs {
      margin-bottom: 80px;
      position: relative;
    }
    .item_logo {
      text-align: center;
      display: inline-block;
      padding: 10px;
      box-sizing: border-box;
      width: calc(100% / 5);
      img {
        width: 120px;
        height: 60px;
      }
      .logoname {
        color: #ccc;
        font-size: 24px;
        padding: 40px 0;
      }
    }

    .title {
      text-align: center;
      font-size: 26px;
      color: #333;
      padding: 100px 0 40px 0;
    }
    .van-cell {
      padding: 0;
    }
    .p {
      font-size: 26px;
      color: #333;
      padding: 60px 0;
    }
    .P1 {
      font-size: 24px;
      color: #999;
    }
  }
  .footer {
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 20px 0;
    right: 0;
    background: #fff;
    .yellowbg {
      background: #f8d541;
      width: 600px;
      border-radius: 44px;
      font-size: 26px;
      color: #333;
      text-align: center;
      margin: 0 auto;
      padding: 20px;
    }
  }
  .heigth200 {
    height: 260px;
    overflow: hidden;
  }
  .fex {
    position: relative;
  }
}
</style>